(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList]
              .filter((cl) => cl.indexOf('disclosure') === 0)
              .forEach((cl) => {
                el.classList.remove(cl);
                el.classList.add(`mobile-${cl}`);
              });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList]
              .filter((cl) => cl.indexOf('mobile-disclosure') === 0)
              .forEach((cl) => {
                el.classList.remove(cl);
                el.classList.add(cl.substr(7));
              });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["human-hydrate-ebook-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('klaviyo-ebook-form')) {
    customElements.define(
      'klaviyo-ebook-form',
      class KlaviyoEbookForm extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.form = this.querySelector('form');
          this.emailInput = this.querySelector('input[type="email"]');
          this.phoneInput = this.querySelector('input[type="tel"]');
          this.submitButton = this.querySelector('button[type="submit"]');
          this.downloadButton = this.querySelector('[data-download-button]');
          this.formFields = this.querySelector('[data-form-fields]');
          this.errorMessage = this.querySelector('[data-form-error]');
          this.successMessage = this.querySelector('[data-form-success]');
          this.defaultButtonLabel = this.submitButton?.textContent;

          this.form?.addEventListener('submit', this.handleSubmit.bind(this));
          this.downloadButton?.addEventListener('click', (event) => {
            if (this.downloadButton.getAttribute('aria-disabled') === 'true') {
              event.preventDefault();
            }
          });
        }

        async handleSubmit(event) {
          event.preventDefault();
          this.clearError();

          if (!this.form.checkValidity()) {
            this.form.reportValidity();
            return;
          }

          const companyId = this.dataset.companyId?.trim();
          const listId = this.dataset.listId?.trim();

          if (!companyId || !listId) {
            this.showError('This form is temporarily unavailable. Please try again later.');
            return;
          }

          const phoneNumber = this.normalizePhoneNumber(this.phoneInput.value);

          if (!phoneNumber) {
            this.showError('Enter a valid phone number, including the country code.');
            return;
          }

          this.setLoading(true);

          try {
            const response = await fetch(
              `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  revision: '2026-07-15',
                },
                body: JSON.stringify({
                  data: {
                    type: 'subscription',
                    attributes: {
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: this.emailInput.value.trim(),
                            phone_number: phoneNumber,
                            subscriptions: {
                              email: {
                                marketing: {
                                  consent: 'SUBSCRIBED',
                                },
                              },
                              sms: {
                                marketing: {
                                  consent: 'SUBSCRIBED',
                                },
                              },
                            },
                          },
                        },
                      },
                      custom_source: 'HUMAN Summer Backyard eBook',
                    },
                    relationships: {
                      list: {
                        data: {
                          type: 'list',
                          id: listId,
                        },
                      },
                    },
                  },
                }),
              },
            );

            if (!response.ok) throw new Error(`Klaviyo returned ${response.status}`);

            this.formFields.hidden = true;
            this.successMessage.hidden = false;
            this.enableDownload();
            this.successMessage.focus();
          } catch (error) {
            console.error('Klaviyo eBook signup failed:', error);
            this.showError('We could not submit your information. Please try again.');
          } finally {
            this.setLoading(false);
          }
        }

        setLoading(isLoading) {
          this.submitButton.disabled = isLoading;
          this.submitButton.textContent = isLoading
            ? this.dataset.loadingLabel
            : this.defaultButtonLabel;
        }

        normalizePhoneNumber(value) {
          const trimmedValue = value.trim();
          const digits = trimmedValue.replace(/\D/g, '');

          if (trimmedValue.startsWith('+') && digits.length >= 10 && digits.length <= 15) {
            return `+${digits}`;
          }

          if (digits.length === 10) return `+1${digits}`;
          if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;

          return null;
        }

        enableDownload() {
          const downloadUrl = this.downloadButton?.dataset.downloadUrl;

          if (!this.downloadButton || !downloadUrl) return;

          this.downloadButton.href = downloadUrl;
          this.downloadButton.removeAttribute('aria-disabled');
          this.downloadButton.removeAttribute('tabindex');
        }

        clearError() {
          this.errorMessage.hidden = true;
          this.errorMessage.textContent = '';
          this.emailInput.removeAttribute('aria-invalid');
          this.phoneInput.removeAttribute('aria-invalid');
        }

        showError(message) {
          this.errorMessage.textContent = message;
          this.errorMessage.hidden = false;
          this.emailInput.setAttribute('aria-invalid', 'true');
          this.phoneInput.setAttribute('aria-invalid', 'true');

          if (message.startsWith('Enter a valid phone')) {
            this.phoneInput.focus();
          } else {
            this.emailInput.focus();
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["human-hydrate-flavors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hydrate-flavor-carousel')) {
    class HydrateFlavorCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-flavor-slide]')];
        this.lifestyleSlides = [...this.querySelectorAll('[data-flavor-lifestyle]')];
        this.dots = [...this.querySelectorAll('[data-flavor-dot]')];
        this.currentIndex = 0;

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
      }

      handleClick = (event) => {
        const dot = event.target.closest('[data-flavor-dot]');

        if (dot) {
          this.showSlide(Number(dot.dataset.index));
          return;
        }

        if (event.target.closest('[data-flavor-previous]')) {
          this.showSlide(this.currentIndex - 1);
        }

        if (event.target.closest('[data-flavor-next]')) {
          this.showSlide(this.currentIndex + 1);
        }
      };

      handleKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          this.showSlide(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          this.showSlide(this.currentIndex + 1);
        }
      };

      showSlide(index) {
        if (this.slides.length < 2) return;

        this.currentIndex = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== this.currentIndex;
        });

        this.lifestyleSlides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== this.currentIndex;
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === this.currentIndex ? 'true' : 'false');
        });
      }
    }

    customElements.define('hydrate-flavor-carousel', HydrateFlavorCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-col-image"]) return;
  try {
    
  // Any JavaScript here

  } catch(e) { console.error(e); }
})();
})();
